module.exports = __webpack_public_path__ + "img/1.a0ea7559.jpg";